<template>
  <div class="p-3 card mb-3">
    <fccTratamentoColegiosBusca
      :cidades-de-prova="cidadesDeProva"
      @buscar="listarRelacoesDosColegios"
    />

    <fccTratamentoColegiosTabela
      :relacoes-dos-colegios="relacoesDosColegios"
      @atualizar="atualizarRelacao"
      @excluir="excluirRelacao"
      v-if="relacoesDosColegios.length > 0"
    />

    <fccAlteracoesColegios
      :tratamento-colegios="tratamentoColegios"
      v-if="tratamentoColegios.length > 0"
    />
  </div>
</template>
<script>
import fccTratamentoColegiosBusca from './fccTratamentoColegiosBusca.vue'
import fccTratamentoColegiosTabela from './fccTratamentoColegiosTabela.vue'
import fccAlteracoesColegios from './fccAlteracoesColegios.vue'
import axios from 'axios'
import store from '../../../../../store'

export default {
  components: {
    fccTratamentoColegiosBusca,
    fccTratamentoColegiosTabela,
    fccAlteracoesColegios
  },
  data() {
    return {
      relacoesDosColegios: [],
      tratamentoColegios: [],
      idCidadeDeProva: null
    }
  },
  props: ['cidadesDeProva'],
  computed: {
    configuracao() {
      return store.state.localDeProva.configuracao
    }
  },
  watch: {
    configuracao() {
      this.relacoesDosColegios = []
      this.listarTratamentoColegios()
    }
  },
  created() {
    this.listarTratamentoColegios()
  },
  methods: {
    listarRelacoesDosColegios(id) {
      this.idCidadeDeProva = id
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          store.state.baseUrlLocalDeProva + `Colegio/RelacaoDosColegios/${id}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          if (response.data.length === 0) {
            this.callAlert('A busca não retornou resultados.', '', 'error', 'error')
          }
          this.relacoesDosColegios = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarTratamentoColegios() {
      axios
        .get(
          store.state.baseUrlLocalDeProva +
            `Colegio/ListarTratamentoColegiosPorIdLocalConfig/${this.configuracao.idlocalconfig}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.tratamentoColegios = response.data
        })
        .catch(this.setErrorSystem)
    },
    atualizarRelacao(payload) {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .put(
          store.state.baseUrlLocalDeProva + `Colegio/TramentoColegioAtualizar`,
          payload,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast('Atualizado com sucesso', 'success')
          this.listarRelacoesDosColegios(this.idCidadeDeProva)
          this.listarTratamentoColegios()
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    excluirRelacao(payload) {
      this.callConfirm(`Tem certeza que deseja excluir?`, '').then(() => {
        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .put(
            store.state.baseUrlLocalDeProva + `Colegio/TramentoColegioExcluir`,
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.callToast(this.mensagensUpdate.excluido, 'success')
            this.listarRelacoesDosColegios(this.idCidadeDeProva)
            this.listarTratamentoColegios()
          })
          .catch(this.setErrorSystem)
          .finally(this.carregaTexto)
      })
    }
  }
}
</script>
  